import script from "./MsgReplyMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgReplyMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MsgReplyMenu.vue?vue&type=style&index=0&id=746eed41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746eed41"]])

export default __exports__